import {Typography} from 'components/Typography';
import {FC, useCallback, useContext} from 'react';
import style from './style.module.scss';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {showModal} from 'modules/modals/thunks';
import {MODALS} from 'modules/modals/constants';
import {EventsListContext} from 'modules/events/context';
import classNames from 'classnames';

export const BannerCertificate: FC = () => {
    const dispatch = useAppDispatch();

    const {isLoading} = useContext(EventsListContext);

    const onButtonClick = useCallback(() => {
        dispatch(showModal(MODALS.TASTING_CERTIFICATE_INFO.name));
    }, [dispatch]);

    return (
        <div className={classNames(style.main, {[style.isLoading]: isLoading})} data-skeleton-item={true}>
            <Typography variant={'ch-display-42-reg'}>Подарочный сертификат на мероприятие с дегустацией</Typography>
            <button className={style.button} type={'button'} onClick={onButtonClick}>
                <Typography variant={'label-14-r-fluid'}>Подробнее</Typography>
            </button>
        </div>
    );
};
